// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__MXroh","action":"styles_action__1qHw7","field":"styles_field__1KliP"};